import React from 'react';

const NonImmigrationVisas: React.FC = () => (
  <div className="bg-white min-h-screen text-left flex flex-col items-center py-10 px-4 pt-20">
    <div className="max-w-7xl w-full px-0 md:px-10">
      <div className="flex flex-col md:flex-row items-center gap-8 mb-10">
        <div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#0097b2] mb-4 leading-tight">Non Immigration Visas</h1>
          <p className="text-[21px] text-gray-700 mb-2">We provide legal services for a variety of non-immigrant visa categories, including H1B, L1, O1/O3, J-1, and E1/E2. Our attorneys help clients navigate the application process and maintain compliance with U.S. immigration laws.</p>
        </div>
      </div>
    </div>
  </div>
);

export default NonImmigrationVisas;
